mutation RemoveCompetitor($boardId: ID!, $competitorId: ID!) {
  result: StreamToolsRemoveCompetitor(boardId: $boardId, competitorId: $competitorId) {
    id
    deleted
  }
}
